<template>
  <div v-show="show" :style="{ 'z-index': (currentZIndex-1)}">
    <div :style="{ 'z-index': (currentZIndex)}" class="dimmed_black" style="top:0;display:block;"></div>
    <!--popup 시작-->
    <div
      :style="{ 'z-index': (currentZIndex+1)}"
      class="rew19_popContainer big"
      id="pop_changeServicelife"
      style="display:block;"
    >
      <div class="rew19_popup_wrap">
        <h2>
          <span class="rew19_basketList_tit">기념일 변경</span>
          <button class="rew19_basketList_btn" @click="onCancel">
            <span>닫기</span>
          </button>
        </h2>
      </div>

      <div class="rew19_popup_cont">
        <ul class="rew19_underline_list type2">
          <li class="type2">
            <em>현재 기념일</em>
            <span class="substance">
              {{viewData.rawData.dspAnniversary}}
              <span v-if="viewData.coupon.couponDate"
                class="rew19_flag type01">발급완료</span>
            </span>
          </li>
          <li class="type2">
            <em>기념일 변경</em>
            <span class="substance">
              <select 
                v-model.number="viewData.resData.selMonth"
                class="rew19_select_t1 autoFocus"
                @change="onChangeMonth">
                <option v-for="m in 12" :value="m" :key="m">{{m}}월</option>
              </select>

              <select 
                v-model.number="viewData.resData.selDate"
                class="rew19_select_t1 autoFocus">                
                <option v-for="d in MONTH_DAYS[viewData.resData.selMonth-1]" 
                  :key="d"
                  :value="d">{{d}}일</option>
              </select>
            </span>
          </li>
        </ul>        
        <ul class="rew19_small_dotList">
          <li>기념일 쿠폰은 1년에 한 번 지급되며, 한 번 발급되면 사용 여부와 관계없이 추가 발급되지 않습니다.</li>
          <li>뉴스킨 회원 정보에 등록된 생일을 기준으로 쿠폰이 발급되며, 기념일은 변경이 가능합니다.</li>
          <li>단, 당해 년도에 기념일 쿠폰을 사용하신 경우 기념일을 변경하더라도 재발급되지 않으며 다음 년도에 쿠폰을 받으실 수 있습니다.</li>
          <li>기념일 쿠폰은 기념일의 월 1일에 발급되며, 당월 말일까지 사용이 가능합니다. 기간 내 사용하지 않는 경우 쿠폰은 소멸되며 재발급되지 않습니다.</li>
          <li>기념일 변경은 익월 1일자로 반영되며, 변경 당월로 변경 시 쿠폰이 즉시 발급되지는 않습니다.</li>
        </ul>
      </div>
      <!--//rew19_popup_cont-->

      <div class="rew19_popup_btn rew19_clear">
        <button class="rew19_popHarf disabled" @click="onCancel">취소</button>
        <button class="rew19_popHarf activation" @click="onOk">확인</button>
      </div>
    </div>
  </div>
</template>
<script>
import * as ErrMsg from "@/utils/error_msg";

const MONTH_DAYS = [31,29,31,30,31,30,31,31,30,31,30,31];
const DEFAULT_MEMBERSHIP_INFO = {
  rawData: {
    // anniversaryInfo: "08-13",
    // message: "조회성공",
    // status: "0000",
    // dspAnniversary : "8월 13일",
    // strMonth : "08",
    // strDate : "13",
  },
  coupon : {

  },
  resData: {
    selMonth : "",
    selDate : "",
    anniversaryInfo : "",
  }
};

export default {
  name: "ChangeServicelifeDialog",
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentZIndex: 2000,
      MONTH_DAYS : MONTH_DAYS,

      viewData: DEFAULT_MEMBERSHIP_INFO
    };
  },
  watch: {
    show(show) {
      this.$modalAfterTreat(show);

      show &&
        this.$nextTick(() => {
          let _this = this;
          _this.currentZIndex = _this.$getDimmMaxIndex() + 2;

          this.$el.focus();
        });
    }
  },
  updated: function () {
    this.$nextTick(function () {
      $(".rew19_popContainer.big .rew19_popup_cont").css('height', $(window).height() - 102); 
    })
  },
  mounted() {
    let _this = this;
  },
  methods: {
    onClose(response) {
      let _this = this;

      let retData = null;
      if (response) {
        retData = _this.viewData.resData;
      }

      _this.$emit("close", response, response ? retData : null);
    },

    onCancel() {
      this.onClose(false);
    },

    onOk() {
      let _this = this;

      //Make value
      let vObj = _this.viewData.resData;
      let strDate = `${vObj.selMonth > 9 ? ''+vObj.selMonth : '0'+vObj.selMonth}-${vObj.selDate > 9 ? ''+vObj.selDate : '0'+vObj.selDate}`;
      _this.viewData.resData.anniversaryInfo = strDate;
      

      //기본 날짜 확인
      if(!_this.validation()){
        return;
      }

      let today = new Date();
      if(_this.viewData.coupon.couponDate){
        //쿠폰이 발급되어 있는 경우        
        let testRx = new RegExp(`^${today.getFullYear()}`, "g");
        let msg = "";
        if(testRx.test(_this.viewData.coupon.couponDate)){
          msg = `
          회원님은 올해 기념일 쿠폰을 이미 받으셨습니다.<br/>
          변경하신 기념일은 내년부터 적용됩니다.<br/>
          기념일을 변경하시겠습니까?`;
        }else{
          msg = `기념일을 변경하시겠습니까?`;
        }

        _this.$dialogs.confirm(msg, {cancelLabel: '취소', okLabel:'확인'}).then(res=>{
          if(res.ok){
            _this.onClose(true);
          }
        });          
        return;

      }else{
        //쿠폰이 발급되지 않은 경우

        let curMonth = today.getMonth()+1;
        let msg = '';
        if(curMonth == 12){
          //변경을 시도하는 날이 12월일경우
          msg = `
            기념일 쿠폰은 내년부터 사용이 가능합니다.<br/>
            선택하신 기념일은 ${vObj.selMonth}월 ${vObj.selDate}일 이고 기념일 쿠폰은
            ${vObj.selMonth}월 1일에 발급될 예정입니다.<br/>
            기념일을 변경하시겠습니까?`;
          
        }else if(curMonth >= vObj.selMonth){
          //변경하고자 하는 날이 당월 또는 지나간 날짜
          msg = `
            회원님은 올해 기념일 쿠폰을 아직 수령하지 않으셨습니다.<br/>
            기념일 날짜를 다음 월 1일부터 12월 31일 이내로 다시 선택해 주세요.<br/>
            기념일 쿠폰은 월 초에 발행됩니다 `;
          
          //[경고 및 중단]
          _this.$dialogs.alert(msg).then(res => {});
          return;

        }else {
          //이번 연도 남은 날짜 선택
          msg = `
            선택하신 기념일은 ${vObj.selMonth}월 ${vObj.selDate}일 이고 기념일 쿠폰은
            ${vObj.selMonth}월 1일에 발급될 예정입니다.<br/>
            기념일을 변경하시겠습니까?`;
        }

        _this.$dialogs.confirm(msg, {cancelLabel: '취소', okLabel:'확인'}).then(res=>{
          if(res.ok){
            _this.onClose(true);
          }
        });
      }
    },

    /**
     * API Request
     */
    //기념일 쿠폰 발행일
    apiGetAnniversaryCoupon : function(){
      let _this = this;
      return _this.$http.get(`${_this.$aroApiBasePath}/aro/anniversary_coupon`, {
        params: {}
      });
    },

    /**
     * Local
     */
    initData(paramData) {
      let _this = this;

      _this.viewData = {
        ..._this.viewData,
        rawData : {...paramData}
      };

      _this.viewData.resData.selMonth = _this.viewData.rawData.strMonth ? 
        parseInt(_this.viewData.rawData.strMonth, 10) : 1;  

      _this.viewData.resData.selDate = _this.viewData.rawData.strDate ? 
        parseInt(_this.viewData.rawData.strDate, 10) : 1;  
      
      _this.viewData.resData.anniversaryInfo = "";

      _this.loadData();
    },

    loadData(){
      let _this = this;

      //show loading
      _this.$showLoading();
      _this.apiGetAnniversaryCoupon().then(res=>{
        
        if (res.status === 200 && res.data.status === "0000") {          
          _this.viewData.coupon = {...res.data};
        }else{
          //Fail
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }
      }).catch(()=>{
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});        

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    },

    validation(){
      let _this = this;

      if(_this.viewData.resData.anniversaryInfo == _this.viewData.rawData.anniversaryInfo){
        _this.$dialogs.alert("변경하고자 하는 날짜와 기존 기념일과 동일합니다.").then(res => {});
        return false;
      }

      return true;
    },

    validation(){
      let _this = this;

      if(_this.viewData.resData.anniversaryInfo == _this.viewData.rawData.anniversaryInfo){
        _this.$dialogs.alert("변경하고자 하는 날짜와 기존 기념일과 동일합니다.").then(res => {});
        return false;
      }

      if(!_this.viewData.coupon.couponDate){        
        let today = new Date();
        if((today.getMonth()+1) == _this.viewData.resData.selMonth){
          let msg = `회원님은 올해 기념일 쿠폰을 아직 수령하지 않으셨습니다.<br/>
            기념일 날짜를 다음 달부터 올해 이내로 선택해 주세요.`;
          _this.$dialogs.alert(msg).then(res => {});
          return false;
        }        
      }
      
      return true;
    },

    onChangeMonth(){
      let _this = this;

      let maxDays = _this.MONTH_DAYS[_this.viewData.resData.selMonth-1];
      if(_this.viewData.resData.selDate > maxDays){
        _this.viewData.resData.selDate = 1;
      }
    }
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/popup/ChangeServicelifeDialog.vue